<template>
  <div class="flex flex-col md:flex-row gap-3">
    <Field
      :rules="requiredRule"
      name="estabDepartmentId"
      v-slot="{ field, errors: errs, handleChange }"
    >
      <Dropdown
        :field="field"
        :errors="errs"
        :label="$t('establishmentDepartment')"
        :options="departments"
        :fuse-options="{
          threshold: 0.9
        }"
        class="px-0.5 w-full md:w-1/2"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></Dropdown>
    </Field>
    <Field
      v-if="fields.estabDepartmentId === 8"
      name="fieldsNum"
      v-slot="{ field, errors: errs, handleChange }"
    >
      <RadioGroup
        :field="field"
        :errors="errs"
        :radio-options="[
          {
            label: $t('twoFields'),
            value: 2
          },
          {
            label: $t('threeFields'),
            value: 3
          }
        ]"
        :default-value="field.value"
        class="px-1.5 w-full md:w-1/2"
        @on-change="
          (item) => {
            handleChange(item.value)
            resetField('establishmentNumber')
            resetField('establishmentSponsorType')
            resetField('establishmentType')
          }
        "
      >
      <template #labelSlot>
        <div class="hidden md:block">&nbsp;</div>
      </template>
    </RadioGroup>
    </Field>
  </div>
  <div class="w-full md:w-4/5 flex flex-col gap-y-1">
    <span>
      {{ $t('establishmentCardNumber') }}
      <span class="text-brand-red">*</span>
    </span>
    <div class="flex items-center gap-x-3">
      <Field :rules="requiredRule" name="establishmentNumber" v-slot="{ field, errors: errs }">
        <TextInput
          :field="field"
          :errors="errs"
          :placeholder="$t('estabNumber')"
          :max-length="10"
          mask="##########"
          class="w-2/5"
          label-class="w-full"
          direction="flex-col"
        >
          <template #label></template>
        </TextInput>
      </Field>
      <span class="font-sans pb-2 text-brand-black-secondary">/</span>
      <Field :rules="requiredRule" name="establishmentSponsorType" v-slot="{ field, errors: errs }">
        <TextInput
          :field="field"
          :errors="errs"
          :placeholder="$t('sponsorType')"
          :max-length="2"
          mask="##"
          class="w-1/4 md:w-1/5"
          label-class="w-full"
          direction="flex-col"
        >
          <template #label></template>
        </TextInput>
      </Field>
      <template v-if="fields.estabDepartmentId === 8 && fields.fieldsNum === 3">
        <span class="font-sans pb-2 text-brand-black-secondary">/</span>
        <Field :rules="requiredRule" name="establishmentType" v-slot="{ field, errors: errs }">
          <TextInput
            :field="field"
            :errors="errs"
            :placeholder="$t('establishmentType')"
            :max-length="3"
            mask="###"
            class="w-1/4 md:w-1/5"
            label-class="w-full"
            direction="flex-col"
          >
            <template #label></template>
          </TextInput>
        </Field>
      </template>
    </div>
  </div>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import Dropdown from '@/components/SimpleForm/Dropdown.vue'
import RadioGroup from '@/components/SimpleForm/RadioGroup.vue'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

defineProps({
  departments: Array,
  fields: Object,
  resetField: Function
})

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}
</script>

<style lang="scss" scoped></style>
